import enrollmentContextApi from '../../../services/plataforma/enrollment/context';
import enrollmentTopicApi from '../../../services/plataforma/enrollment/content';
import enrollmentTaskApi from '../../../services/plataforma/enrollment/task';
import enrollmentQuizApi from '../../../services/plataforma/enrollment/quiz';
import enrollmentProgressApi from '../../../services/plataforma/enrollment/progress';
import enrollmentUserApi from '../../../services/plataforma/enrollment/user';
import ContentType from '@/helpers/contentType';

export default {
  actionGetContext({ commit }, enrollmentId) {
    return enrollmentContextApi.getContextAndMenu(enrollmentId)
      .then((response) => {
        commit('plataforma/content/SET_MENU', response.data, { root: true });
        commit('plataforma/courses/SET_USER_PERMISSIONS', response.data.context.permissions, { root: true });
        commit('SET_ENROLLMENT_CONTEXT', response.data.context);

        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err.response);
      });
  },
  actionGetTopicContent({ commit }, { enrollmentId, topic }) {
    return enrollmentTopicApi.getTopicContent({ enrollmentId, topicId: topic.id })
      .then((response) => {
        const selectedTopic = {
          ...response.data,
          ...topic
        };

        commit('SET_SELECTED_TOPIC', selectedTopic);
        commit('plataforma/content/SET_VIEWED_TOPIC_ID', selectedTopic.id, { root: true });

        return Promise.resolve();
      })
      .catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionGetQuizContent({ commit }, { enrollmentId, topic }) {
    return enrollmentQuizApi.getQuizContent({ enrollmentId, topicId: topic.id })
      .then((response) => {
        const selectedTopic = {
          content: response.data,
          ...topic
        };

        commit('SET_SELECTED_TOPIC', selectedTopic);

        return Promise.resolve();
      })
      .catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionAnswerQuizQuestion(_, { enrollmentId, topic, questionId, optionId }) {
    return enrollmentQuizApi.answerQuestion({ enrollmentId, topicId: topic.topicId, questionId, optionId })
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionFinishQuizAttempt(_, { enrollmentId, topic, attemptId }) {
    return enrollmentQuizApi.finishAttempt({ enrollmentId, topicId: topic.topicId, attemptId })
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionGetTaskContent({ commit }, { enrollmentId, topic }) {
    return enrollmentTaskApi.getTaskContent({ enrollmentId, topicId: topic.id })
      .then((response) => {
        const selectedTopic = {
          content: response.data,
          ...topic
        };

        commit('SET_SELECTED_TOPIC', selectedTopic);
        commit('plataforma/content/SET_VIEWED_TOPIC_ID', selectedTopic.id, { root: true });

        return Promise.resolve();
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionAnswerTask(_, { enrollmentId, topicId, data }) {
    return enrollmentTaskApi.sendTaskAnswer({ enrollmentId, topicId, data })
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionGetPageChildrensContent({ commit }, { enrollmentId, topic }) {
    return enrollmentTopicApi.getPageChildrensContent({ enrollmentId, topicId: topic.id })
      .then((response) => {
        const selectedTopic = {
          ...topic,
          children: response.data
        };

        commit('SET_SELECTED_TOPIC', selectedTopic);

        return Promise.resolve();
      })
      .catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  getParticipants(_, params) {
    return enrollmentUserApi.getParticipants(params)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  getNotEnrolled(_, { academicMainId, type, filter, page, limit }) {
    return enrollmentUserApi.getNotEnrolled({ academicMainId, type, filter, page, limit })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  createEnrollments(_, { academicMainId, users, roleCourseId, enrollmentStatusId, startDate, endDate }) {
    return enrollmentUserApi.createEnrollments({ academicMainId, users, roleCourseId, enrollmentStatusId, startDate, endDate })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  update(_, { userId, roleCourseId, enrollmentStatusId, startDate, endDate }) {
    return enrollmentUserApi.update({ userId, roleCourseId, enrollmentStatusId, startDate, endDate })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  delete(_, { id }) {
    return enrollmentUserApi.delete(id)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  actionAddProgress({ commit, rootState }, { enrollmentId, topicId }) {
    let topic = rootState.plataforma.enrollment.selectedTopic;

    if (ContentType.PAGE === rootState.plataforma.enrollment.selectedTopic.topicTypeId) {
      topic = rootState.plataforma.enrollment.selectedTopic.children.find((item) => item.id === topicId);
    }

    if (!topic.viewed && topic.isBeforeDeadline) {
      return enrollmentProgressApi.create({ enrollmentId, topicId })
        .then(() => {
          commit('plataforma/content/SET_TOPIC_VIEWED_ON_MENU', { topicId, viewed: true }, { root: true });
          commit('SET_TOPIC_VIEWED_ON_SELECTED', { topicId, viewed: true });

          return Promise.resolve();
        })
        .catch((err) => {
          return Promise.reject(err.response.data.error.message);
        });
    }
  },
  actionGetPostsByTopicId({ commit }, { enrollmentId, topicId }) {
    return enrollmentTopicApi.getPostsByTopicId({ enrollmentId, topicId })
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionDeleteDelivery(_, { enrollmentId, topicId, attemptNumber, topicType }) {
    return enrollmentUserApi.deleteDelivery({ enrollmentId, topicId, attemptNumber, topicType })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  actionDeletePost(_, { enrollmentId, topicId, postId }) {
    return enrollmentUserApi.deletePost({ enrollmentId, topicId, postId })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  actionGetStudents(_, data) {
    return enrollmentUserApi.getStudents(data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error);
      });
  }
};
